export const ALLOWED_SOURCE_DOMAINS: readonly string[] = [
  "facebook.com",
  "x.com",
  "twitter.com",
  "instagram.com",
  "telefuturo.com.py",
];
